import * as React from "react";
import clsx from "clsx";
import { BusinessReportOutcomeStatus } from "@/modules/snapshots/businessReports.types";
import { Tooltip } from "@/components/ui/tooltip";

interface Props {
  status: BusinessReportOutcomeStatus;
  errorMessage?: string | null;
}

export const BusinessReportsOutcomeListRowStatus: React.FC<Props> = ({ status, errorMessage }) => {
  const badge = (
    <span
      className={clsx("inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset", {
        "bg-gray-50 text-gray-600 ring-gray-500/10": status === "NEW",
        "bg-red-50 text-red-700 ring-red-600/10": status === "FAILED",
        "bg-green-50 text-green-700 ring-green-600/20": status === "COMPLETED",
        "bg-indigo-50 text-indigo-700 ring-indigo-700/10": status === "IN_PROGRESS",
        "bg-orange-50 text-orange-700 ring-orange-600/10": status === "CANCELLED",
      })}
    >
      {status.replace(/[_-]/g, " ").toUpperCase()}
    </span>
  );

  if (status === "FAILED" && errorMessage) {
    return (
      <Tooltip
        text={<span className="block max-w-xs">{errorMessage}</span>}
        className="rounded bg-black text-sm text-white"
      >
        <span className="cursor-help">{badge}</span>
      </Tooltip>
    );
  }

  return badge;
};
